import React, { useState } from 'react';
import { FaEnvelope, FaPhone, FaCopy, FaCheck } from 'react-icons/fa';

const ContactButton = ({ email, phone, variant = "default" }) => {
  const [copied, setCopied] = useState(false);

  // Função para copiar o email para a área de transferência
  const handleCopyEmail = () => {
    if (email) {
      navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  // Função para abrir o cliente de email
  const handleEmailClick = () => {
    if (email) {
      window.location.href = `mailto:${email}`;
    }
  };

  // Função para fazer ligação
  const handlePhoneClick = () => {
    if (phone) {
      window.location.href = `tel:${phone}`;
    }
  };

  // Variante compacta - botão único com ambas informações
  if (variant === "compact") {
    return (
      <div className="relative">
        <button 
          onClick={handleEmailClick}
          className="w-full bg-blue-800 hover:bg-blue-900 text-white font-medium py-3 px-6 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 flex items-center justify-center gap-2 text-sm"
        >
          <FaEnvelope className="text-base" />
          <span className="truncate">
            {email && phone ? `${email} / ${phone}` : email || phone || "Contato"}
          </span>
        </button>
      </div>
    );
  }

  // Variante com botões separados
  if (variant === "split") {
    return (
      <div className="flex gap-3">
        {email && (
          <button 
            onClick={handleEmailClick}
            className="flex-1 bg-blue-500 hover:bg-blue-600 text-white font-medium py-3 px-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 flex items-center justify-center gap-2"
          >
            <FaEnvelope />
            <span className="hidden sm:inline">Email</span>
          </button>
        )}
        
        {phone && (
          <button 
            onClick={handlePhoneClick}
            className="flex-1 bg-blue-500 hover:bg-blue-600 text-white font-medium py-3 px-4 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 flex items-center justify-center gap-2"
          >
            <FaPhone />
            <span className="hidden sm:inline">Telefone</span>
          </button>
        )}
      </div>
    );
  }

  // Variante com cards (padrão)
  return (
    <div className="space-y-3">
      {/* Card de Email */}
      {email && (
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:border-blue-300 transition-colors duration-300">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="bg-blue-500 text-white p-2 rounded-lg">
                <FaEnvelope className="text-lg" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-gray-500 font-medium">Email</p>
                <a 
                  href={`mailto:${email}`}
                  className="text-sm text-gray-800 hover:text-blue-600 transition-colors truncate block"
                >
                  {email}
                </a>
              </div>
            </div>
            <button
              onClick={handleCopyEmail}
              className="ml-2 p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
              title="Copiar email"
            >
              {copied ? <FaCheck className="text-blue-600" /> : <FaCopy />}
            </button>
          </div>
        </div>
      )}

      {/* Card de Telefone */}
      {phone && (
        <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:border-blue-300 transition-colors duration-300">
          <div className="flex items-center gap-3">
            <div className="bg-blue-500 text-white p-2 rounded-lg">
              <FaPhone className="text-lg" />
            </div>
            <div className="flex-1">
              <p className="text-xs text-gray-500 font-medium">Telefone</p>
              <a 
                href={`tel:${phone}`}
                className="text-sm text-gray-800 hover:text-blue-600 transition-colors"
              >
                {phone}
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactButton;